(() => {
  'use strict';
  function init(root = document) {
    const controls = [...root.querySelectorAll('[data-gs-motion-toggle]')];
    if (!controls.length || controls.every(button => button.dataset.ready)) return;
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = media.matches;
    const apply = () => {
      document.body.classList.toggle('gs-motion-enabled', !paused && !media.matches);
      document.body.classList.toggle('gs-motion-paused', paused || media.matches);
      controls.forEach(button => {
        button.textContent = paused || media.matches ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-pressed', String(paused || media.matches));
      });
    };
    controls.forEach(button => {
      button.dataset.ready = 'true';
      button.addEventListener('click', () => { paused = !paused; apply(); });
    });
    media.addEventListener('change', () => { paused = media.matches; apply(); });
    apply();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('gs-seen'); observer.unobserve(entry.target); }
      }), {threshold: .25});
      root.querySelectorAll('.gs-motion-target').forEach(element => observer.observe(element));
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
